import { render, staticRenderFns } from "./IcoCallout2.vue?vue&type=template&id=8cdf7628"
import script from "./IcoCallout2.vue?vue&type=script&lang=js"
export * from "./IcoCallout2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports